export default "__VITE_ASSET__CmovHsTw__"